import { render, staticRenderFns } from "./OrganizationPastEventsListContainer.vue?vue&type=template&id=50535a6c&scoped=true"
import script from "./OrganizationPastEventsListContainer.vue?vue&type=script&lang=js"
export * from "./OrganizationPastEventsListContainer.vue?vue&type=script&lang=js"
import style0 from "./OrganizationPastEventsListContainer.vue?vue&type=style&index=0&id=50535a6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50535a6c",
  null
  
)

export default component.exports